<template>
  <div id="app">
    <div class="">
      <div class="container">
        <ListView :account-id="accountId" :page-size="pageSize" :include-past="includePast" :only-past="onlyPast"/>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<script>

import ListView from '../components/list/template1/ListView'

export default {
  props: {
    accountId: {
      type: String
    },
    eventId: {
      type: String
    },
    pageSize: {
      type: Number
    },
    templateId: {
      type: Number
    },
    includePast: {
      type: Boolean
    },
    onlyPast: {
      type: Boolean
    },
  },
  data() {
    return {}
  },
  components: {
    ListView
  },
  name: 'App',
  mounted() {
  },
  beforeMount() {
  },
}

</script>
